module.exports = __webpack_public_path__ + "static/media/laura3.9ed97261.png";